<mat-dialog-content class="mat-typography">
	<p>{{ message }}</p>
	<mat-progress-bar mode="indeterminate"></mat-progress-bar>
</mat-dialog-content>
<br>
<mat-dialog-actions align="end">
	<button class="cancel-popup" mat-stroked-button (click)="cancel()">Close</button>
</mat-dialog-actions>
